import { render, staticRenderFns } from "./NovidadeAdminForm.vue?vue&type=template&id=6f7beef2&"
import script from "./NovidadeAdminForm.vue?vue&type=script&lang=js&"
export * from "./NovidadeAdminForm.vue?vue&type=script&lang=js&"
import style0 from "./NovidadeAdminForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VCombobox,VIcon,VRow,VSelect,VTooltip})
